import {Component, Input, OnInit, inject, DestroyRef} from '@angular/core';
import { translate } from '@jsverse/transloco';
import { ToastrService } from 'ngx-toastr';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { DateTimeFormatService } from 'src/app/services/util/date-time-format.service';
import { UrlService } from 'src/app/services/util/url.service';
import { Subject } from 'rxjs';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ActivatedRoute, Router } from '@angular/router';
import { InstancesService } from 'src/app/services/api/instances.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { AuthService } from 'src/app/services/auth/auth.service';
import { RouterSegments } from 'src/app/models/router-segments';
import { ToastrErrorService } from 'src/app/services/util/toastr-error.service';


@Component({
    selector: 'app-external-instance-details',
    templateUrl: './external-instance-details.component.html',
    styleUrls: ['./external-instance-details.component.scss'],
    standalone: false
})
export class ExternalInstanceDetailsComponent  implements OnInit {

  public rightExpanded: boolean;
  displayedColumns: string[] = ['subscriptionId', 'subscriptionName', 'dataZone'];
  solutionDisplayedColumns: string[] = ['name', 'value'];
private destroyRef = inject(DestroyRef);
  RouterSegments = RouterSegments;

  instanceId: string;
  tenantId: string;
  solutionId: string;
  data: any;
  solution: any;
  breadcrumbItems: BreadcrumbItem[] = [];
  isLoading = true;

  private afterClosed$ = new Subject<any>();
  constructor(public dateTimeFormatService: DateTimeFormatService, private toastrService: CustomToastrService,
    public urlService: UrlService , private sidenavService: SidenavService, private activatedRoute: ActivatedRoute,
    private instanceService: InstancesService, private solutionsService: SolutionsService, private router: Router,
    private authService: AuthService, private toastrErrorService: ToastrErrorService) {
      
  }

  ngOnInit(): void {
    this.instanceId = this.activatedRoute.snapshot.params.instanceId;
    this.getInstanceDetails();

    this.breadcrumbItems.push({icon: 'assets/images/home_icon.svg'}, {label: translate('LEFT_SIDE_NAV.DASHBOARDS'), url:[]},
      {label: translate('LEFT_SIDE_NAV.EXTERNAL_INSTANCE'), url: ['external-instance']});
    this.instanceId = this.activatedRoute.snapshot.params.instanceId;
  }

  getInstanceDetails(): void {
    this.instanceService.getInstanceDetails(this.instanceId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
          this.data = data;
          this.breadcrumbItems.push({label: data.name, url: [RouterSegments.EXTERNAL_INSTANCE, data.id]});
          this.data.solution = data;
          this.getInstanceDetailsById();
          if(this.data.solutionId) {
            this.getSolutionById(this.data.solutionId);
          }

        }
      },
      (error) => {
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
      this.isLoading = false;
  }

  getInstanceDetailsById(): void {
    this.instanceService.getInstanceDetailsById(this.data?.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
          this.data.details = data;
        }
      },
      (error) => {
      //   // this.toastrService.clear();
      // setTimeout(() => {
      //   this.toastrService.errorMessage(
      //     `${error?.message ? error?.message : (error?.error?.message ? error?.error?.message
      //       : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')))}`
      //     );
      // }, 500);
      });
  }

  getSolutionById(solutionId): void {
    this.solutionsService.getSolutionById(solutionId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(result => {
      this.solution = result;
    },
    (error) => {
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
    });
  }

    getRleaseVersions(solutionId,targetSolutionVersionId): void {
    if(targetSolutionVersionId) {
      this.solutionsService.getSolutionVersion(solutionId, targetSolutionVersionId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(task => {
      },
      (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
    }
  }



  goToInstances(): void {
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.EXTERNAL_INSTANCE]);
  }

  closeSidenav(): void {
    this.sidenavService.closeRightSidenav();
  }

}
